// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"PokemonDetail_mainContainer__1LpNn","catchButton":"PokemonDetail_catchButton__p3Eoo"};